import { Link } from "react-router-dom";

interface ServerErrorPageProps {
  error?: Error | null;
  onReset?: () => void;
}

export function ServerErrorPage({ error, onReset }: ServerErrorPageProps) {
  const detail = error?.message?.trim();

  function handleRetry() {
    if (onReset) onReset();
    window.location.reload();
  }

  return (
    <div className="mx-auto max-w-2xl px-6 py-24 text-center">
      <p className="mb-3 text-caption font-medium uppercase tracking-widest text-primary">
        Fehler
      </p>
      <h1 className="mb-3 font-display text-h1 uppercase text-primary">
        Etwas ist schiefgelaufen
      </h1>
      <p className="mb-6 text-body-sm text-ink-soft">
        Wir konnten deine Anfrage nicht verarbeiten. Versuch es bitte gleich noch einmal.
        Wenn das Problem bestehen bleibt, melde dich gern bei uns.
      </p>
      {detail ? (
        <p className="mx-auto mb-6 max-w-md break-words rounded-card bg-surface-warm px-4 py-3 text-caption text-ink-muted">
          {detail}
        </p>
      ) : null}
      <div className="flex flex-wrap items-center justify-center gap-4">
        <button
          type="button"
          onClick={handleRetry}
          className="rounded-card bg-primary px-5 py-2 text-body-sm font-medium text-white hover:opacity-90"
        >
          Erneut versuchen
        </button>
        <Link to="/" className="text-body-sm text-primary underline">
          Zur Startseite
        </Link>
      </div>
    </div>
  );
}
